import axios from "axios";
import { BASE_API_URL, API_URLS } from '../constants';
import { errorMessage } from '../components/Toaster';

const apiClient = axios.create({
  baseURL: BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Function to get a new access token
const refreshToken = async () => {
  try {
    const response = await axios.get(API_URLS.AUTH.REFRESH_TOKEN, { withCredentials: true });
    if (response.data?.data?.refresh_token) {
      const newToken = response.data.data.refresh_token;

      // Store new access token
      localStorage.setItem("auth_token", newToken);
      return newToken;
    }

    throw new Error("Invalid response from refresh API");
  } catch (error) {
    throw error;
  }
};

// Add request interceptor to attach the token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle expired tokens
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return apiClient(originalRequest);
      } catch (err) {
        errorMessage("Session expired. Redirecting to login...");
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
